import $ from 'jquery';

const accordion = {
  init : (elementHtmlTag) => {
    /*
    * Init
    * */
    $(elementHtmlTag).find('li.accordion--item').each((index, accordionItemElement) => {
      _accordionPrivate.openItem($(accordionItemElement), true);
    });

    /*
    * Add event
    * */
    $(elementHtmlTag).find('button.accordion--button').on('click', (e) => {
      _accordionPrivate.open($(e.currentTarget), $(elementHtmlTag));
    });
  },
};

const _accordionPrivate = {
  isExists : (htmlElement) => {
    return htmlElement
      && htmlElement.length > 0
      && typeof htmlElement != 'undefined';
  },
  open : (accordionButtonElement, accordionElement) => {
    /*
    * Check if valid variable
    * */
    if (!_accordionPrivate.isExists(accordionButtonElement)) {
      return;
    }

    /*
    * Get area to expand
    * */
    let accordionItemElement = accordionButtonElement.closest('li');

    /*
    * Check if need to open a specific accordion
    * Do it before close all accordions
    * */
    let hadClassOpen = !accordionItemElement.hasClass('accordion--close');

    /*
    * Close all accordions
    * */
    accordionElement.find('li.accordion--item').each((index, accordionItemElement) => {
      _accordionPrivate.openItem($(accordionItemElement), true);
    });

    /*
    * Open the one if needed
    * */
    if (!hadClassOpen) {
      _accordionPrivate.openItem(accordionItemElement, false);
    }
  },
  openItem : (accordionItemElement, close) => {
    close = close || false;

    accordionItemElement
      .removeClass(close ? 'accordion--open' : 'accordion--close')
      .addClass(close ? 'accordion--close' : 'accordion--open');
    accordionItemElement.find('.accordion--content')
      .attr('aria-expanded', !close)
      .attr('aria-hidden', close);
  },
};

export default accordion;
